import {
  FETCH_RECOMMENDED_AI_SKU_MAPPINGS,
  REJECT_AI_SKU_MAPPING,
  UPDATE_AI_SKU_MAPPING,
  APPROVE_AI_SKU_MAPPING,
  DECREMENT_UNREVIEWED_RECOMMENDATIONS_COUNT,
} from "../actions/types";
import { STATUS } from "../components/AiSkuMapping/constants";

const initialState = {
  data: {
    response: [],
    total: 0,
    unreviewedRecommendationsCount: 0,
    approvedRecommendations: [],
  },
};

export default function aiSkuMappingReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_RECOMMENDED_AI_SKU_MAPPINGS:
      return {
        data: {
          response: action.payload.response,
          total: action.payload.total,
          unreviewedRecommendationsCount: action.payload.total,
          approvedRecommendations: [...state.data.approvedRecommendations],
        },
      };
    case APPROVE_AI_SKU_MAPPING: {
      const approvedRecommendation = state.data.response.find(
        (item) => item._id === action.payload,
      );
      if (!approvedRecommendation) {
        return state;
      }

      const approvedRecommendations = [
        ...state.data.approvedRecommendations,
        approvedRecommendation,
      ];
      return {
        ...state,
        data: {
          ...state.data,
          approvedRecommendations,
          response: state.data.response.map((item) =>
            item._id === action.payload
              ? { ...item, status: STATUS.MAPPED }
              : item,
          ),
        },
      };
    }

    case REJECT_AI_SKU_MAPPING: {
      const rejectedRecommendation = state.data.response.find(
        (item) => item._id === action.payload,
      );
      if (!rejectedRecommendation) {
        return state;
      }

      const approvedRecommendations = state.data.approvedRecommendations.filter(
        (item) => item._id !== rejectedRecommendation._id,
      );
      return {
        ...state,
        data: {
          ...state.data,
          approvedRecommendations,
          response: state.data.response.map((item) =>
            item._id === action.payload
              ? { ...item, status: STATUS.UNMAPPED }
              : item,
          ),
        },
      };
    }

    case UPDATE_AI_SKU_MAPPING: {
      const { id, data } = action.payload;

      const recommendation = state.data.response.find(
        (item) => item._id === id,
      );

      if (!recommendation) return state;

      let approvedRecommendations = state.data.approvedRecommendations;

      if (data.status === STATUS.MAPPED) {
        approvedRecommendations = [...approvedRecommendations, recommendation];
      } else if (data.status === STATUS.UNMAPPED) {
        approvedRecommendations = approvedRecommendations.filter(
          (item) => item._id !== recommendation._id,
        );
      }

      return {
        ...state,
        data: {
          ...state.data,
          approvedRecommendations,
          response: state.data.response.map((resItem) =>
            resItem._id === id ? { ...resItem, status: data.status } : resItem,
          ),
        },
      };
    }

    case DECREMENT_UNREVIEWED_RECOMMENDATIONS_COUNT:
      return {
        ...state,
        data: {
          ...state.data,
          unreviewedRecommendationsCount:
            state.data.unreviewedRecommendationsCount > 0
              ? state.data.unreviewedRecommendationsCount - 1
              : 0,
        },
      };
    default:
      return state;
  }
}
